var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "84%",
      "height": "auto",
      "is-loc": "center"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [this.setting.popadv && this.setting.popadv.id ? _c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "adv-title"
  }, [_vm._v(" Congratulations,you have obtained the face scaning privilege ")]), _c('div', {
    staticClass: "adv-content"
  }, [_vm._v(" You can complete multiple face scan verifications to receive multiple rewards ")]), _c('div', {
    staticClass: "btn-confirm",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Verify ")])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };